module.exports = __webpack_public_path__ + "static/media/soul_goals.096888f3.jpg";